import { Tooltip, Typography, TypographyProps, styled } from '@mui/material';
import { ZINDEX } from '../../constants/styles';

const TextContainer = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  :hover {
    overflow: visible;
    position: relative;
    padding-right: 5px;
    z-index: ${ZINDEX.ELLIPSIS_TEXT};
  }
`;

export const EllipsisText = (props: TypographyProps) => {
  return (
    <Tooltip title={props.children} disableFocusListener followCursor placement='right-end'>
      <TextContainer data-testid='ellipsis-text' variant={'body2'} whiteSpace={'nowrap'} {...props}>
        {props.children}
      </TextContainer>
    </Tooltip>
  );
};

export const TypographyWithTooltip = (props: TypographyProps) => {
  return (
    <Tooltip title={props.children} placement='top'>
      {/* The anchor must hug its text: as a stretched grid/flex item it would fill the whole track,
          and `placement='top'` centres the tooltip on the anchor box, not the glyphs. */}
      <Typography
        {...props}
        sx={[
          { maxWidth: '100%', width: 'fit-content' },
          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
      >
        {props.children}
      </Typography>
    </Tooltip>
  );
};
